var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYandexMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6993_51922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7035 20C7.18828 20 2.70508 15.5329 2.70508 10.0168C2.70508 4.50072 7.18828 0 12.7035 0C18.2187 0 22.7019 4.50072 22.7019 10.0192C22.7019 15.5353 18.2187 20 12.7035 20Z",
    fill: "#FF5226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1552 1.35352L0 18.7611H5.1144L11.5584 8.7275L11.4 8.65548L9.6144 15.835L13.3968 16.5023L17.2848 11.6152L17.0736 11.5095L15.7608 17.0592L24.0024 15.4894L22.32 12.7217L19.3488 13.401L19.6992 13.8043L21.0816 8.00738L17.8584 5.85183L13.6416 11.1591L13.8504 11.2647L15.5832 4.31079L11.1552 1.35352Z",
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1552 1.35352L0 18.7611H5.1144L11.5584 8.7275L11.4 8.65548L9.6144 15.835L13.3968 16.5023L17.2848 11.6152L17.0736 11.5095L15.7608 17.0592L19.0728 16.4279L21.084 8.00498L17.8608 5.84943L13.6416 11.1591L13.8504 11.2647L15.5832 4.31079L11.1552 1.35352Z",
    fill: "#FFDD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6993_51922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexMarket);
export default __webpack_public_path__ + "static/media/YandexMarket.d17350cf2ccfca94e46ff538bbb3584d.svg";
export { ForwardRef as ReactComponent };